const UNIT_MAP: { [unit: string]: string } = {
  CEL: 'c',
  E14: 'kcal',
  GRM: 'g',
  HLT: 'hl',
  KGM: 'kg',
  KJO: 'kj',
  LTR: 'l',
  MGM: 'mg',
  MLT: 'ml',
  MC: 'μg',
  NIU: 'IU',
  P1: '%',
}

export const formatProductQuantityUnit = (unit: string | undefined | null): string | null => {
  return unit ? UNIT_MAP[unit] || unit?.toLowerCase() : null
}
